import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth, API_URL } from '../../context/AuthContext';
import AdminNav from './AdminNav';

export default function AdminPanel() {
  const { usuario, logout } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [esMobile, setEsMobile] = useState(() => window.innerWidth <= 600);
  const [modalPass, setModalPass] = useState(false);
  const [passForm, setPassForm] = useState({ actual: '', nueva: '', rep: '' });
  const [passError, setPassError] = useState('');
  const [passOk, setPassOk] = useState(false);
  const [passCargando, setPassCargando] = useState(false);

  useEffect(() => {
    const check = () => setEsMobile(window.innerWidth <= 600);
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  useEffect(() => {
    if (usuario?.rol !== 'admin') { navigate('/'); return; }
    axios.get(`${API_URL}/admin/stats`).then(r => setStats(r.data)).catch(() => {});
  }, []);

  const abrirModalPass = () => {
    setPassForm({ actual: '', nueva: '', rep: '' });
    setPassError('');
    setPassOk(false);
    setModalPass(true);
  };

  const cambiarPassword = async (e) => {
    e.preventDefault();
    if (passForm.nueva.length < 6) return setPassError('La nueva contraseña debe tener al menos 6 caracteres');
    if (passForm.nueva !== passForm.rep) return setPassError('Las contraseñas no coinciden');
    setPassError(''); setPassCargando(true);
    try {
      await axios.put(`${API_URL}/auth/cambiar-password`, {
        password_actual: passForm.actual,
        password_nuevo: passForm.nueva,
      });
      setPassOk(true);
      setTimeout(() => setModalPass(false), 1500);
    } catch (err) {
      setPassError(err.response?.data?.error || 'Error al cambiar la contraseña');
    } finally { setPassCargando(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#FFF0F5' }}>
      <AdminNav
        esMobile={esMobile}
        tipo="panel"
        botonExtra={{ label: '🏠 Inicio', labelMobile: '🏠', ruta: '/seleccion' }}
      />

      <div style={{ padding: esMobile ? '20px 14px 80px' : '32px 24px', maxWidth: '1100px' }} className="fade-in">
        <h1 style={{ color: '#581C47', fontSize: esMobile ? '22px' : '28px', marginBottom: '6px' }}>Panel de Administración</h1>
        <p style={{ color: '#BE84A3', marginBottom: '32px', fontSize: '14px' }}>Gestión completa de Su Academia</p>

        {/* ── Sección Finanzas ── */}
        {stats && (
          <div style={{ marginBottom: '36px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
              <div style={{ width: '4px', height: '20px', borderRadius: '2px', background: 'linear-gradient(180deg, #EC4899, #F59E0B)' }} />
              <h2 style={{ color: '#581C47', fontSize: '17px', margin: 0, fontFamily: 'Inter, sans-serif', fontWeight: 700 }}>Finanzas</h2>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: esMobile ? '1fr' : 'repeat(3, 1fr)', gap: '10px' }}>
              {/* Total Alumnos */}
              <div style={{
                background: 'linear-gradient(135deg, #FFF0F5 0%, #FFFFFF 100%)',
                border: '1px solid #FBCFE8',
                borderRadius: '12px',
                padding: '14px 16px',
                boxShadow: '0 2px 10px rgba(236,72,153,0.07)',
                display: 'flex', alignItems: 'center', gap: '14px',
              }}>
                <div style={{ background: 'rgba(236,72,153,0.1)', border: '1px solid rgba(236,72,153,0.2)', borderRadius: '10px', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px', flexShrink: 0 }}>👥</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
                    <span style={{ fontSize: '24px', fontWeight: 900, fontFamily: 'Inter, sans-serif', color: '#EC4899', lineHeight: 1 }}>{stats.totalAlumnos ?? '—'}</span>
                    <span style={{ background: 'rgba(236,72,153,0.1)', color: '#EC4899', fontSize: '10px', fontWeight: 700, padding: '2px 6px', borderRadius: '20px' }}>ALUMNOS</span>
                  </div>
                  <div style={{ color: '#BE84A3', fontSize: '12px', marginTop: '2px' }}>Total registrados</div>
                </div>
              </div>

              {/* Alumnos Activos */}
              <div style={{
                background: 'linear-gradient(135deg, #F0FDF4 0%, #FFFFFF 100%)',
                border: '1px solid #A7F3D0',
                borderRadius: '12px',
                padding: '14px 16px',
                boxShadow: '0 2px 10px rgba(52,211,153,0.07)',
                display: 'flex', alignItems: 'center', gap: '14px',
              }}>
                <div style={{ background: 'rgba(52,211,153,0.12)', border: '1px solid rgba(52,211,153,0.25)', borderRadius: '10px', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px', flexShrink: 0 }}>✅</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
                    <span style={{ fontSize: '24px', fontWeight: 900, fontFamily: 'Inter, sans-serif', color: '#34D399', lineHeight: 1 }}>{stats.alumnosActivos ?? '—'}</span>
                    <span style={{ background: 'rgba(52,211,153,0.12)', color: '#059669', fontSize: '10px', fontWeight: 700, padding: '2px 6px', borderRadius: '20px' }}>ACTIVOS</span>
                  </div>
                  <div style={{ color: '#6EE7B7', fontSize: '12px', marginTop: '2px' }}>Con acceso vigente</div>
                  {stats.totalAlumnos > 0 && (
                    <div style={{ marginTop: '6px' }}>
                      <div style={{ height: '3px', background: 'rgba(52,211,153,0.15)', borderRadius: '2px', overflow: 'hidden' }}>
                        <div style={{ height: '100%', width: `${Math.round((stats.alumnosActivos / stats.totalAlumnos) * 100)}%`, background: 'linear-gradient(90deg, #34D399, #6EE7B7)', borderRadius: '2px', transition: 'width 0.6s ease' }} />
                      </div>
                      <span style={{ fontSize: '10px', color: '#34D399', fontWeight: 700 }}>{Math.round((stats.alumnosActivos / stats.totalAlumnos) * 100)}% activos</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Ingresos Totales */}
              <div style={{
                background: 'linear-gradient(135deg, #FFFBEB 0%, #FFFFFF 100%)',
                border: '1px solid #FDE68A',
                borderRadius: '12px',
                padding: '14px 16px',
                boxShadow: '0 2px 10px rgba(245,158,11,0.07)',
                display: 'flex', alignItems: 'center', gap: '14px',
              }}>
                <div style={{ background: 'rgba(245,158,11,0.12)', border: '1px solid rgba(245,158,11,0.25)', borderRadius: '10px', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px', flexShrink: 0 }}>💶</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
                    <span style={{ fontSize: '22px', fontWeight: 900, fontFamily: 'Inter, sans-serif', color: '#F59E0B', lineHeight: 1 }}>{stats.totalPagos?.toFixed(2) || '0.00'}€</span>
                    <span style={{ background: 'rgba(245,158,11,0.12)', color: '#D97706', fontSize: '10px', fontWeight: 700, padding: '2px 6px', borderRadius: '20px' }}>INGRESOS</span>
                  </div>
                  <div style={{ color: '#FCD34D', fontSize: '12px', marginTop: '2px' }}>Ingresos acumulados</div>
                </div>
              </div>
            </div>
          </div>
        )}

        <h2 style={{ color: '#581C47', fontSize: '17px', marginBottom: '14px' }}>Acciones rápidas</h2>
        <div style={{ display: 'grid', gridTemplateColumns: esMobile ? '1fr' : 'repeat(auto-fill, minmax(240px, 1fr))', gap: '12px', marginBottom: '36px' }}>
          {[
            { icon: '👥', label: 'Gestión de Usuarios',    desc: 'Crear, editar y eliminar alumnos y profesores',     ruta: '/admin/usuarios',           color: '#EC4899', bg: 'rgba(236,72,153,0.06)' },
            { icon: '💳', label: 'Pagos y PayPal',         desc: 'Ver suscripciones, cancelar y cambiar precios',     ruta: '/admin/pagos',              color: '#F472B6', bg: 'rgba(244,114,182,0.06)' },
            { icon: '🔑', label: 'Accesos Temporales',     desc: 'Genera códigos de acceso con fecha de expiración',  ruta: '/admin/accesos-temporales', color: '#8B5CF6', bg: 'rgba(139,92,246,0.06)' },
            { icon: '📢', label: 'Avisos',                 desc: 'Publica mensajes visibles para los alumnos',        ruta: '/admin/avisos',             color: '#F59E0B', bg: 'rgba(245,158,11,0.06)' },
            { icon: '🛡️', label: 'Seguridad y Actividad', desc: 'Sesiones, inactividad y bloqueo de IPs',            ruta: '/admin/seguridad',          color: '#DB2777', bg: 'rgba(219,39,119,0.06)' },
            { icon: '🎖️', label: 'Sección Militar',       desc: 'Acceder a todo el contenido militar',               ruta: '/militar/SLP2/temario',     color: '#7C3AED', bg: 'rgba(124,58,237,0.06)' },
            { icon: '🎓', label: 'Sección Civil',          desc: 'Acceder a todo el contenido civil',                 ruta: '/civil/B1/temario',         color: '#BE84A3', bg: 'rgba(190,132,163,0.06)' },
          ].map(item => (
            <div
              key={item.ruta}
              onClick={() => navigate(item.ruta)}
              style={{
                background: '#FFFFFF',
                border: '1px solid #FBCFE8',
                borderLeft: `4px solid ${item.color}`,
                borderRadius: '14px',
                padding: esMobile ? '14px 16px' : '18px 20px',
                cursor: 'pointer',
                boxShadow: '0 2px 12px rgba(236,72,153,0.06)',
                display: 'flex',
                alignItems: 'center',
                gap: '14px',
                transition: 'transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = `0 8px 24px ${item.color}25`;
                e.currentTarget.style.background = item.bg;
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 12px rgba(236,72,153,0.06)';
                e.currentTarget.style.background = '#FFFFFF';
              }}
            >
              <div style={{
                width: esMobile ? '40px' : '44px',
                height: esMobile ? '40px' : '44px',
                borderRadius: '12px',
                background: item.bg,
                border: `1px solid ${item.color}30`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: esMobile ? '20px' : '22px',
                flexShrink: 0,
              }}>
                {item.icon}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ color: '#581C47', fontWeight: 700, fontFamily: 'Inter, sans-serif', fontSize: '14px', marginBottom: esMobile ? 0 : '3px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.label}</p>
                {!esMobile && <p style={{ color: '#BE84A3', fontSize: '12px', margin: 0 }}>{item.desc}</p>}
              </div>
              <span style={{ color: '#D1A3BE', fontSize: '16px', flexShrink: 0 }}>›</span>
            </div>
          ))}
          <div
            onClick={abrirModalPass}
            style={{
              background: '#FFFFFF',
              border: '1px solid #FBCFE8',
              borderLeft: '4px solid #6366F1',
              borderRadius: '14px',
              padding: esMobile ? '14px 16px' : '18px 20px',
              cursor: 'pointer',
              boxShadow: '0 2px 12px rgba(236,72,153,0.06)',
              display: 'flex',
              alignItems: 'center',
              gap: '14px',
              transition: 'transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 8px 24px rgba(99,102,241,0.18)';
              e.currentTarget.style.background = 'rgba(99,102,241,0.05)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 12px rgba(236,72,153,0.06)';
              e.currentTarget.style.background = '#FFFFFF';
            }}
          >
            <div style={{
              width: esMobile ? '40px' : '44px',
              height: esMobile ? '40px' : '44px',
              borderRadius: '12px',
              background: 'rgba(99,102,241,0.06)',
              border: '1px solid rgba(99,102,241,0.18)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: esMobile ? '20px' : '22px',
              flexShrink: 0,
            }}>
              🔒
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <p style={{ color: '#581C47', fontWeight: 700, fontFamily: 'Inter, sans-serif', fontSize: '14px', marginBottom: esMobile ? 0 : '3px' }}>Cambiar contraseña</p>
              {!esMobile && <p style={{ color: '#BE84A3', fontSize: '12px', margin: 0 }}>Actualiza la contraseña de tu cuenta admin</p>}
            </div>
            <span style={{ color: '#D1A3BE', fontSize: '16px', flexShrink: 0 }}>›</span>
          </div>
        </div>

        {stats?.pagosRecientes?.length > 0 && (
          <>
            <h2 style={{ color: '#581C47', fontSize: '17px', marginBottom: '14px' }}>Pagos recientes</h2>
            {esMobile ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {stats.pagosRecientes.map(p => (
                  <div key={p.id} style={{ background: '#FFFFFF', border: '1px solid #FBCFE8', borderRadius: '12px', padding: '14px 16px', boxShadow: '0 2px 8px rgba(236,72,153,0.05)' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                      <p style={{ color: '#581C47', fontWeight: 600, fontSize: '14px' }}>{p.nombre}</p>
                      <span style={{ color: '#34D399', fontWeight: 700, fontSize: '15px', fontFamily: 'monospace' }}>{p.monto}€</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ background: p.estado === 'completado' ? '#34D39918' : '#FCE7F3', color: p.estado === 'completado' ? '#34D399' : '#EC4899', borderRadius: '6px', padding: '2px 10px', fontSize: '11px', fontWeight: 700 }}>
                        {p.estado.toUpperCase()}
                      </span>
                      <span style={{ color: '#BE84A3', fontSize: '12px' }}>{new Date(p.fecha).toLocaleDateString('es-ES')}</span>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="table-scroll">
                <table style={{ borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ borderBottom: '1px solid #FBCFE8', background: '#FFF0F5' }}>
                      {['Alumno', 'Importe', 'Estado', 'Fecha'].map(h => (
                        <th key={h} style={{ padding: '12px 16px', color: '#BE84A3', fontSize: '12px', textAlign: 'left', fontFamily: 'Inter, sans-serif', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {stats.pagosRecientes.map(p => (
                      <tr key={p.id} style={{ borderBottom: '1px solid #FCE7F3' }}>
                        <td style={{ padding: '12px 16px', color: '#581C47', fontSize: '14px', fontFamily: 'Inter, sans-serif' }}>{p.nombre}</td>
                        <td style={{ padding: '12px 16px', color: '#34D399', fontSize: '14px', fontWeight: 600, fontFamily: 'Inter, sans-serif' }}>{p.monto}€</td>
                        <td style={{ padding: '12px 16px' }}>
                          <span style={{ background: p.estado === 'completado' ? '#34D39918' : '#FCE7F3', color: p.estado === 'completado' ? '#34D399' : '#EC4899', borderRadius: '6px', padding: '2px 10px', fontSize: '11px', fontWeight: 700 }}>
                            {p.estado.toUpperCase()}
                          </span>
                        </td>
                        <td style={{ padding: '12px 16px', color: '#BE84A3', fontSize: '13px' }}>{new Date(p.fecha).toLocaleDateString('es-ES')}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>

      {/* Modal cambiar contraseña */}
      {modalPass && (
        <div style={{
          position: 'fixed', inset: 0, zIndex: 9999,
          background: 'rgba(88,28,71,0.5)', backdropFilter: 'blur(4px)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px',
        }} onClick={e => { if (e.target === e.currentTarget) setModalPass(false); }}>
          <div style={{ background: '#fff', borderRadius: '20px', padding: '32px 28px', width: '100%', maxWidth: '400px', boxShadow: '0 24px 64px rgba(88,28,71,0.2)' }}>
            <h2 style={{ color: '#581C47', fontSize: '18px', fontWeight: 700, marginBottom: '6px' }}>🔒 Cambiar contraseña</h2>
            <p style={{ color: '#BE84A3', fontSize: '13px', marginBottom: '22px' }}>Cuenta: {usuario?.email}</p>

            {passOk ? (
              <div style={{ background: '#ECFDF5', border: '1px solid #A7F3D0', borderRadius: '12px', padding: '16px', textAlign: 'center', color: '#065F46', fontWeight: 600 }}>
                ✅ Contraseña actualizada correctamente
              </div>
            ) : (
              <form onSubmit={cambiarPassword}>
                {passError && (
                  <div style={{ background: 'rgba(236,72,153,0.08)', border: '1px solid rgba(236,72,153,0.3)', borderRadius: '10px', padding: '10px 14px', color: '#DB2777', fontSize: '13px', marginBottom: '16px' }}>
                    {passError}
                  </div>
                )}
                {[
                  { label: 'Contraseña actual', key: 'actual' },
                  { label: 'Nueva contraseña', key: 'nueva' },
                  { label: 'Repetir nueva contraseña', key: 'rep' },
                ].map(f => (
                  <div key={f.key} style={{ marginBottom: '14px' }}>
                    <label style={{ display: 'block', color: '#EC4899', fontSize: '12px', fontWeight: 600, marginBottom: '5px' }}>{f.label}</label>
                    <input
                      type="password"
                      value={passForm[f.key]}
                      onChange={e => setPassForm({ ...passForm, [f.key]: e.target.value })}
                      required
                      style={{ width: '100%', padding: '11px 14px', borderRadius: '10px', background: '#FFF0F5', border: '1px solid #FBCFE8', color: '#581C47', fontSize: '14px', boxSizing: 'border-box' }}
                    />
                  </div>
                ))}
                <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
                  <button type="submit" disabled={passCargando} style={{ flex: 1, padding: '12px', borderRadius: '50px', background: 'linear-gradient(135deg, #EC4899 0%, #F472B6 100%)', border: 'none', color: '#fff', fontSize: '14px', fontWeight: 600, cursor: 'pointer' }}>
                    {passCargando ? 'Guardando...' : 'Guardar'}
                  </button>
                  <button type="button" onClick={() => setModalPass(false)} style={{ padding: '12px 20px', borderRadius: '50px', background: 'none', border: '1px solid #FBCFE8', color: '#BE84A3', fontSize: '14px', cursor: 'pointer' }}>
                    Cancelar
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
